import { render, staticRenderFns } from "./TuiXue.vue?vue&type=template&id=6a372250&scoped=true"
import script from "./TuiXue.vue?vue&type=script&lang=js"
export * from "./TuiXue.vue?vue&type=script&lang=js"
import style0 from "./TuiXue.vue?vue&type=style&index=0&id=6a372250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a372250",
  null
  
)

export default component.exports